"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagSelector = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var languages_1 = require("utils/helpers/languages");
var lang = [
    { id: 'fi' },
    { id: 'sv' },
    { id: 'en' },
    { id: 'de' },
    { id: 'multi' }
];
var FlagSelector = function (props) {
    var _a = React.useState('multi'), selected = _a[0], setSelected = _a[1];
    var flag = (React.createElement("img", { src: (0, languages_1.getLanguageFlag)(selected), alt: selected, style: { width: 15, height: 14 } }));
    var multiFlag = (React.createElement(React.Fragment, null, ['fi', 'sv', 'en'].map(function (lang) { return (React.createElement("img", { key: lang, src: (0, languages_1.getLanguageFlag)(lang), alt: lang, className: "flag-".concat(lang), style: { width: 15, height: 14 } })); })));
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'flag-selector', alignment: 'left' },
        React.createElement(sok_ui_1.TextInput, { editable: false, value: selected !== 'multi' ? flag : multiFlag, iconRight: React.createElement("span", { className: "icon-container" },
                React.createElement(Icon_1.Icon, { className: "fa-chevron-down" })) }),
        React.createElement(sok_ui_1.Dropdown2Menu, null, lang.map(function (item, index) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { selected: item.id === selected, key: "".concat(index, "_").concat(item.id), onClick: function () {
                props.updateLanguage(props.uuid, item.id);
                setSelected(item.id);
            } }, item.id === 'multi' ? (multiFlag) : (React.createElement("img", { src: (0, languages_1.getLanguageFlag)(item.id), alt: item.id, style: { width: 15, height: 14 } })))); }))));
};
exports.FlagSelector = FlagSelector;
